import type {TUserRole} from '~/types/user'

export interface CookieSession {
    exp: number
    role: Exclude<TUserRole, null>
}

export function sessionFromPayload(data: unknown, now = Date.now()): CookieSession | null {
    if (!data || typeof data !== 'object') {
        return null
    }

    const exp = (data as {exp?: unknown}).exp
    const role = (data as {role?: unknown}).role

    if (typeof exp !== 'number' || exp * 1000 <= now) {
        return null
    }

    if (role !== 'client' && role !== 'doctor' && role !== 'clinic') {
        return null
    }

    return {exp, role}
}
